import axios from '@/libs/axios'

export class ReportService {

  static async getReport(params) {
    return new Promise((resolve, reject) => {
      axios.post(`reports`,params)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }
  static async exportReport(params) {
    return new Promise((resolve, reject) => {
      axios.get(`export/report`, { params: params }).then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }
  static async getDevicesOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params })
          .then(res => resolve(res.data))
          .catch(reason => reject(reason.response))
    })
  }
  static async getAreasOptions(params) {
    return new Promise((resolve, reject) => {
      axios.get(`userGetLinked`, { params: params })
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }
}
